var _circle, _circle2, _circle3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMasterNewSkill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 637,
    height: 637,
    viewBox: "0 -59 637 637",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 318.5,
    cy: 259.5,
    r: 204.185,
    stroke: "#151C2B",
    strokeWidth: 28
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 318.5,
    cy: 259.5,
    r: 304.5,
    stroke: "#151C2B",
    strokeWidth: 28
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 318.5,
    cy: 259.5,
    r: 112.854,
    fill: "#212C42"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2265_3630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.266 260.185L358.988 250.691C358.117 250.347 356.325 249.899 354.294 250.691L330.005 260.185C327.727 261.05 326.25 263.138 326.25 265.248C326.25 288.788 340.752 305.073 354.284 310.367C356.314 311.158 358.08 310.71 358.977 310.367C369.787 306.338 387 291.699 387 265.248C387 263.138 385.523 261.05 383.266 260.185ZM356.625 300.537V260.628L376.77 268.513C375.588 286.911 363.923 297.078 356.625 300.537Z",
    fill: "#719CF9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M299.25 257C314.163 257 326.25 244.911 326.25 230C326.25 215.089 314.163 203 299.25 203C284.337 203 272.25 215.089 272.25 230C272.25 244.911 284.337 257 299.25 257ZM319.627 268.454C316.526 267.61 313.298 267.125 309.945 267.125H288.555C268.371 267.125 252 283.515 252 303.702C252 307.73 255.274 311 259.311 311H339.18C339.843 311 340.439 310.788 341.05 310.623C329.984 302.098 320.365 287.438 319.627 268.454Z",
    fill: "#719CF9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2265_3630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 108,
    fill: "white",
    transform: "translate(252 203)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterNewSkill);
export default __webpack_public_path__ + "static/media/master-new-skill.5b3c01266ed9f92112984802c5873b53.svg";
export { ForwardRef as ReactComponent };